import React from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';
import { formatDate } from '../../utils/formatters';

const ResumeSaleModal = ({ isOpen, onClose, heldSales, onResume, onRefresh }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Held Sales" size="lg">
      <div className="resume-sale-modal">
        <div className="modal-header-actions">
          <Button variant="secondary" size="sm" onClick={onRefresh}>
            Refresh
          </Button>
        </div>

        {heldSales.length === 0 ? (
          <p className="no-sales">No held sales found</p>
        ) : (
          <div className="held-sales-list">
            {heldSales.map((sale, index) => (
              <div key={index} className="held-sale-item">
                <div className="sale-info">
                  <span className="sale-date">{formatDate(sale.held_at)}</span>
                  <span className="sale-items">{sale.items_count} items</span>
                  {sale.notes && <span className="sale-notes">{sale.notes}</span>}
                </div>
                <Button 
                  variant="primary" 
                  size="sm"
                  onClick={() => onResume(sale)}
                >
                  Resume
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ResumeSaleModal;